import keyBy from 'lodash/keyBy';

import { DataTransferCost } from '@cast/types';
import { aggregateDataTransferMetrics } from '@cast/utils';

import { dataTransferDatapointAggregator } from 'features/cost-report/utils/networkCosts';
import {
  TopMostExpensiveGroup,
  TopMostExpensiveGroupDatapoint,
} from 'types/top-items';

import { WorkloadDataTransfer } from '../_types';

export const mapWorkloadDataTransfer = (
  data: DataTransferCost[]
): WorkloadDataTransfer[] => {
  return data.map((d) => {
    const { cost, traffic, egress, ingress } = aggregateDataTransferMetrics(
      d.egressMetrics,
      d.ingressMetrics
    );

    return {
      id: d.workloadName! + d.namespace! + d.workloadType,
      workloadName: d.workloadName!,
      namespace: d.namespace!,
      workloadType: d.workloadType!,
      egressMetrics: d.egressMetrics!,
      ingressMetrics: d.ingressMetrics!,
      cost,
      traffic,
      egress,
      ingress,
      destinationAddresses: {
        internet: [],
        interRegion: [],
        interZone: [],
        intraZone: [],
        cloudApi: [],
      },
    };
  });
};

export const mapWorkloadDataTransferToTopMostExpensiveGroupDatapoint = (
  topItems: TopMostExpensiveGroup[],
  data: WorkloadDataTransfer[]
): TopMostExpensiveGroupDatapoint => {
  const workloadByIds = keyBy(topItems, 'id');
  const topWorkloadIds = Object.keys(workloadByIds);

  return Object.values(
    data.reduce((acc, w) => {
      if (topWorkloadIds.includes(`${w.namespace}-${w.workloadName}`)) {
        const name = w.workloadName;
        const aggregatorFn = dataTransferDatapointAggregator.bind(
          null,
          name,
          acc
        );

        w.egressMetrics.forEach(aggregatorFn);
        w.ingressMetrics.forEach(aggregatorFn);
      }

      return acc;
    }, {})
  );
};
